/**
 * OTP length — SINGLE SOURCE OF TRUTH.
 *
 * GoTrue's project-wide `mailer_otp_length` is currently 8. Every surface that
 * accepts an emailed one-time code (admin recovery, admin invite acceptance,
 * consumer S3 verification) MUST read this constant instead of hardcoding a
 * digit count.
 *
 * Follow-up (deferred): moving to 6 digits project-wide requires
 *   (1) mailer_otp_length = 6 set in GoTrue (dashboard access required), and
 *   (2) flipping this constant to 6,
 * deployed together. See docs/SECURITY-INVARIANTS.md.
 */
export const OTP_LENGTH = 8;

/** Human-readable label, e.g. "8-digit". */
export const OTP_LENGTH_LABEL = `${OTP_LENGTH}-digit`;

/** True when `value` is exactly OTP_LENGTH numeric characters. */
export const isCompleteOtp = (value: string) =>
  new RegExp(`^\\d{${OTP_LENGTH}}$`).test(value);

/** Strip non-digits and clamp to OTP_LENGTH. */
export const normalizeOtpInput = (value: string) =>
  value.replace(/\D/g, "").slice(0, OTP_LENGTH);
